import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import primaryNavStyles from '../../PrimaryNavigation.module.scss';
import { useHeadway } from '../../hooks/useHeadway';
import { HeadwayMessageCount } from '..';
import styles from './HelpDropdown.module.scss';
import {
  Icon,
  IconList,
  MenuList,
  MenuItem,
  MenuLink,
  MenuTrigger,
  MenuPopover,
  MenuButton,
} from 'components/core';
import { Inline } from 'components/layout';

type Props = {
  children: React.ReactNode;
};

const HelpDropdown = ({ children }: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    reInitialiseHeadway,
    isHeadwayInitialized,
    isHeadwayMenuOpen,
    headwayMessageCount,
  } = useHeadway({
    selector: '[data-headway-selector]',
    trigger: '[data-headway-trigger]',
  });

  useEffect(() => {
    if (isMenuOpen) {
      reInitialiseHeadway();
    }
  }, [isMenuOpen]);

  const limitMessageCount =
    headwayMessageCount > 9 ? '9+' : headwayMessageCount;
  const ariaLabel =
    headwayMessageCount > 0
      ? `Help menu – ${limitMessageCount} notification${
          headwayMessageCount > 1 ? 's' : ''
        }`
      : 'Help menu';

  return (
    <MenuTrigger onMenuOpenChange={setIsMenuOpen}>
      <MenuButton
        className={primaryNavStyles.PrimaryNavigation_helpMenuButton}
        data-testid="helpDropdownButton"
        aria-label={ariaLabel}
        isNaked
        iconOnly
      >
        <span
          data-headway-selector
          className={styles.HelpDropdown_headwaySelector}
        />
        {children}

        {!isHeadwayMenuOpen && !isMenuOpen && (
          <div className={styles.HelpDropdown_headwayCount}>
            <HeadwayMessageCount count={headwayMessageCount} />
          </div>
        )}
      </MenuButton>
      <MenuPopover placement="bottom end">
        <MenuList>
          <MenuItem
            data-headway-trigger
            className={classNames({ [styles.hidden]: !isHeadwayInitialized })}
            onClick={() => {
              // Dispatch original click that react-aria swallowed
              const trigger = document.querySelector(
                '[data-headway-trigger]'
              ) as HTMLElement;
              trigger?.click();
            }}
          >
            <Inline spacing={2}>
              <Icon icon={IconList.light.faBell} /> Latest changes
            </Inline>
            <span className={primaryNavStyles.HelpDropdown_rightAligned}>
              <HeadwayMessageCount count={headwayMessageCount} />
            </span>
          </MenuItem>
          <MenuLink to="https://support.covidence.org/help" external>
            <Inline spacing={2}>
              <Icon icon={IconList.light.faBookOpen} /> Explore knowledge base
            </Inline>
          </MenuLink>
          <MenuLink
            to="https://support.covidence.org/help/are-you-a-new-covidence-user"
            external
          >
            <Inline spacing={2}>
              <Icon icon={IconList.light.faImageUser} /> Register for a webinar
            </Inline>
          </MenuLink>
        </MenuList>
      </MenuPopover>
    </MenuTrigger>
  );
};

export default HelpDropdown;
